import { createFileRoute } from '@tanstack/react-router';
import { useAdminAuthGuard } from '@/features/admin/hooks';
import { ExtractionRunsPanel } from '@/features/admin/ExtractionRunsPanel';
import { SupportingDocConversionsPanel } from '@/features/admin/SupportingDocConversionsPanel';
import { AdminShell } from '@/features/admin/components/AdminShell';
import { AdminPageHeader } from '@/features/admin/components/AdminPageHeader';
import { AdminLogoutButton } from '@/features/admin/components/AdminLogoutButton';

/**
 * Admin Document Extraction Runs route — platform operator's view of every
 * in-flight (pending) tech-spec extraction plus recent failures, across all
 * companies, with stale builds highlighted and a Retry action on a failed one.
 * Bounces to /admin/login if the admin cookie isn't set.
 */
export const Route = createFileRoute('/admin/extraction-runs')({
  component: AdminExtractionRunsPage,
});

function AdminExtractionRunsPage() {
  useAdminAuthGuard();
  return (
    <AdminShell actions={<AdminLogoutButton />}>
      <AdminPageHeader
        title="Document Extraction Runs"
        subtitle="Every tech-spec extraction currently in flight, across all companies, plus recent failures, and every supporting document that failed or is still converting. Stale items (a worker likely died) are highlighted. Retry a failed one for a fresh attempt."
      />
      <ExtractionRunsPanel />
      <div className="mt-10">
        <SupportingDocConversionsPanel />
      </div>
    </AdminShell>
  );
}
